const UTC_TO_BEIJING_MS = 8 * 60 * 60 * 1000;

/** Display only. Keep API and persisted timestamps as UTC ISO strings. */
export function formatBeijingInstant(value: string): string {
  const timestamp = Date.parse(value);
  if (!Number.isFinite(timestamp)) return value;
  return new Date(timestamp + UTC_TO_BEIJING_MS)
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ');
}

export function formatBeijingMinute(value: string): string {
  return formatBeijingInstant(value).slice(0, 16);
}

export function formatBeijingDate(value: string): string {
  return formatBeijingInstant(value).slice(0, 10);
}

export function formatBeijingBusinessValue(
  key: string,
  value: unknown,
): string | null {
  if (
    key !== '报价有效期' ||
    typeof value !== 'string' ||
    !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(
      value,
    )
  )
    return null;
  return formatBeijingInstant(value);
}

/** Format built-in output identity only; callers retain custom field display rules. */
export function formatBeijingOutputValue(
  key: string,
  value: unknown,
): string | null {
  return key === 'valid_until'
    ? formatBeijingBusinessValue('报价有效期', value)
    : null;
}
